/* eslint-disable max-len */

const ProductStyleList = [
  { name: 'Luxury', label: 'Luxury', value: 'Luxury' },
  { name: 'Futuristic', label: 'Futuristic', value: 'Futuristic' },
  { name: 'High-tech', label: 'High-tech', value: 'High-tech' },
  { name: 'Bohemian', label: 'Bohemian', value: 'Bohemian' },
  { name: 'Scandinavian', label: 'Scandinavian', value: 'Scandinavian' },
  { name: 'Mid-century modern', label: 'Mid-century modern', value: 'Mid-century modern' },
  { name: 'Rustic', label: 'Rustic', value: 'Rustic' },
  { name: 'Farmhouse', label: 'Farmhouse', value: 'Farmhouse' },
  { name: 'Industrial', label: 'Industrial', value: 'Industrial' },
  { name: 'Art Deco', label: 'Art Deco', value: 'Art Deco' },
  { name: 'Minimalism', label: 'Minimalism', value: 'Minimalism' },
  { name: 'Traditional', label: 'Traditional', value: 'Traditional' },
  { name: 'Transitional', label: 'Transitional', value: 'Transitional' },
  { name: 'Contemporary', label: 'Contemporary', value: 'Contemporary' },
  { name: 'Eclecticism', label: 'Eclecticism', value: 'Eclecticism' },
  { name: 'Coastal', label: 'Coastal', value: 'Coastal' },
  { name: 'French Country', label: 'French Country', value: 'French Country' },
  { name: 'Shabby Chic', label: 'Shabby Chic', value: 'Shabby Chic' },
  { name: 'Modern', label: 'Modern', value: 'Modern' },
  { name: 'Mediterranean', label: 'Mediterranean', value: 'Mediterranean' },
  { name: 'Regency', label: 'Regency', value: 'Regency' },
  { name: 'Maximalist', label: 'Maximalist', value: 'Maximalist' },
  { name: 'Japandi', label: 'Japandi', value: 'Japandi' },
  { name: 'Mid-Century', label: 'Mid-Century', value: 'Mid-Century' },
  { name: 'Bauhaus', label: 'Bauhaus', value: 'Bauhaus' },
];

export default ProductStyleList;
